import * as React from 'react';

import LeftPane from 'login-components/Common/PaneLayout/LeftPane/LeftPane';
import * as deploymentConfig from 'login-utils/deploymentConfig';
import * as userUtils from 'login-utils/userUtils';

export class JourneyChooserLeftPane extends React.Component {
  render() {
    const title = `Where are you in the process?`;
    const username = userUtils.getDisplayName();
    const friendlyOrgName = deploymentConfig.get().organization.friendlyName;
    const possibleUserDisplayName = username ? `, ${username}` : '';
    const subtitle =
      `Thanks for being a loyal ${friendlyOrgName} customer${possibleUserDisplayName}. ` +
      `We're here to help you every step of the way.`;
    const appDocumentTitleProps = {
      title: 'Tell us where you are in the process',
    };

    return <LeftPane title={title} subtitle={subtitle} appDocumentTitleProps={appDocumentTitleProps} />;
  }
}

export default JourneyChooserLeftPane;
